import Box from "@mui/material/Box";
import React, { useState, useRef } from "react";
import AddIcon from '@mui/icons-material/Add';
import LoadingButton from "@mui/lab/LoadingButton";
import { Button, TextField, Grid, Tooltip, IconButton } from "@mui/material";
import PostDialog from "../components/PostDialog";
import DeleteIcon from '@mui/icons-material/Delete';
import ImageIcon from '@mui/icons-material/Image';
import Divider from '@mui/material/Divider';
import ArtTrackIcon from '@mui/icons-material/ArtTrack';
import axios from "axios";
import { errorNotify, successNotify } from "../../util/functions";
import { ADMIN_SERVER_BASE_URL, SITEWEB_SERVER_BASE_URL, apiClient } from "../../util/apiClient";
import { addService } from "../../store/siteWebSlice";
import { useDispatch } from "react-redux";
import { IServiceState } from "./interface";

interface IAddProps {
  serviceState: IServiceState;
  setServiceState: (x: IServiceState) => void;
}


const Edit = (props: IAddProps) => {

  //props
  const {
    serviceState, setServiceState
  } = props

  //redux
  const dispatch = useDispatch();

  //fonctions
  const handleInputChange = (e: any) => {
    const { value, name } = e.target
    setServiceState({ ...serviceState, [name]: value })
  }


  return (
    <Box sx={{ flexGrow: 1, width: "100%" }}>
      <Grid
        container
        spacing={2}
        direction="row"
        justifyContent="flex-start"
        alignItems="center"
      >
        <Grid item md={6} xs={12} sm={6}>
          <TextField
            fullWidth
            multiline
            minRows={5}
            size="small"
            name="libService"
            label="Libellé service"
            value={serviceState.libService}
            onChange={handleInputChange}
          />
        </Grid>
      </Grid>

    </Box>

  );
};
export default Edit;

